import { render, staticRenderFns } from "./WarningRecord.vue?vue&type=template&id=9cb57fc2&scoped=true"
import script from "./WarningRecord.vue?vue&type=script&lang=js"
export * from "./WarningRecord.vue?vue&type=script&lang=js"
import style0 from "./WarningRecord.vue?vue&type=style&index=0&id=9cb57fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb57fc2",
  null
  
)

export default component.exports